














































import { Component, Vue, Prop, PropSync } from 'vue-property-decorator'
import { Department } from '@/domain/Department'

@Component
export default class DepartmentDialogComponent extends Vue {
  @PropSync("value", { type: Boolean , default: false, required: false })
  dialog!: boolean

  @PropSync("default", { type: Department, default: () => new Department(), required: true })
  dto!: Department

  @Prop({ default: true })
  isNew!: boolean

  /** バリデーション */
  invalid = false

  /**
   * 初期化
   */
  reset() {
    this.dto = new Department()
  }

  /**
   * キャンセルボタンのクリック
   */  
  onCancel() {
    this.dialog = false
    this.reset()
  }

  /**
   * 確定のクリック
   */  
  onSubmit() {
    this.dialog = false
    this.$emit("input", this.dto)
    this.reset()
  }

}
